import React, { useState, useEffect } from 'react';
import LoaderOverlay from '../../components/LoaderOverlay';
import HeaderGlobal from '../../components/HeaderGlobal';
import styles from '../../styles/PantallaDeProgramasAcademicos.v2.module.css';
import globalStyles from '../../styles/PantallaDeProgramasAcademicos.v2.module.css';
import estudiantesStyles from '../../styles/EstudiantesStyles/Estudiantes.module.css';
import Sidebar from '../../components/Sidebar';
import PeriodosTable from './PeriodosTable';
import NuevoPeriodoModal from './NuevoPeriodoModal';
import { getPeriodos, createPeriodo, updatePeriodo, deletePeriodo } from '../../api/periodos';
import { usePermissions } from '../../hooks/usePermissions';

export default function PantallaPeriodos() {
  const { canCreate, canEdit, canView } = usePermissions();
  const puedeCrear =
    canCreate('Catálogos') ||
    canEdit('Catálogos') ||
    canView('Catálogos');

  const [periodos, setPeriodos] = useState([]);
  const [openNew, setOpenNew] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedPeriodo, setSelectedPeriodo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState('');

  // Cargar periodos al montar el componente
  useEffect(() => {
    loadPeriodos();
  }, []);

  const loadPeriodos = async () => {
    try {
      setLoading(true);
      const data = await getPeriodos();
      console.log('✅ Periodos cargados:', data);
      setPeriodos(data);
    } catch (error) {
      console.error('❌ Error al cargar periodos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleView = (periodo) => {
    setSelectedPeriodo(periodo);
    alert(`Ver periodo: ${periodo.nombre}\nCódigo: ${periodo.codigo}\nPeriodos por año: ${periodo.numPorAno}\nDuración: ${periodo.duracion} semanas\nEstado: ${periodo.estado}`);
  };

  const handleEdit = (periodo) => {
    setSelectedPeriodo(periodo);
    setOpenEdit(true);
  };

  const handleDelete = async (periodo) => {
    if (!window.confirm(`¿Estás seguro de eliminar el periodo "${periodo.nombre}"?`)) return;
    
    try {
      await deletePeriodo(periodo.id);
      await loadPeriodos();
      alert('Periodo eliminado correctamente');
    } catch (error) {
      console.error('Error al eliminar:', error);
      alert('Error al eliminar el periodo');
    }
  };

  const handleCreate = async (data) => {
    try {
      await createPeriodo(data);
      await loadPeriodos();
      setOpenNew(false);
      alert('Periodo creado correctamente');
    } catch (error) {
      console.error('Error al crear:', error);
      alert('Error al crear el periodo');
    }
  };

  const handleUpdate = async (data) => {
    try {
      await updatePeriodo(selectedPeriodo.id, data);
      await loadPeriodos();
      setOpenEdit(false);
      setSelectedPeriodo(null);
      alert('Periodo actualizado correctamente');
    } catch (error) {
      console.error('Error al actualizar:', error);
      alert('Error al actualizar el periodo');
    }
  };

  const handleSearch = () => {
    // En el futuro se puede filtrar PeriodosTable usando `query`
    console.log('Buscando periodos con término:', query);
  };

  return (
    <div className={globalStyles.mainContainer}>
      <div className={globalStyles.layout}>
        <div className={globalStyles.sidebarColumn}>
          <Sidebar />
        </div>
        <div className={globalStyles.contentColumn}>
          <HeaderGlobal title="Periodos Académicos" />
          <main className={globalStyles.mainContent}>
            <div className={globalStyles.contentArea}>
              <div className={globalStyles.contentWrapper} style={{ position: 'relative' }}>
                <LoaderOverlay visible={loading} label="Cargando periodos..." />
                <div className={estudiantesStyles.searchSection}>
                  <div className={estudiantesStyles.searchCard}>
                    <div className={globalStyles.programsSearchRow}>
                      <div className={estudiantesStyles.searchInputGroup}>
                        <svg
                          className={estudiantesStyles.searchIcon}
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                            stroke="#898d8d"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <input
                          type="text"
                          className={estudiantesStyles.searchInput}
                          placeholder="Buscar Periodo Académico..."
                          aria-label="Buscar periodo académico"
                          value={query}
                          onChange={(e) => setQuery(e.target.value)}
                          onKeyPress={(e) => {
                            if (e.key === 'Enter') handleSearch();
                          }}
                        />
                      </div>
                      <button
                        className={globalStyles.buscarButtonProgramas}
                        onClick={handleSearch}
                      >
                        Buscar
                      </button>
                      {puedeCrear && (
                        <button
                          className={globalStyles.newProgramButton}
                          aria-label="Nuevo periodo"
                          onClick={() => setOpenNew(true)}
                        >
                          + Nuevo Periodo
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <PeriodosTable
                  periodos={periodos}
                  loading={loading}
                  onView={handleView}
                  onEdit={handleEdit}
                  onDelete={handleDelete}
                />
                <NuevoPeriodoModal
                  open={openNew}
                  onClose={() => setOpenNew(false)}
                  onSubmit={handleCreate}
                />
                <NuevoPeriodoModal
                  open={openEdit}
                  onClose={() => { setOpenEdit(false); setSelectedPeriodo(null); }}
                  onSubmit={handleUpdate}
                  initialData={selectedPeriodo}
                  editMode={true}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
